import { Activity } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { OverviewActivity } from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/client-extensions";

import { isArrayOf, isObjectOf, isRecord, isString } from "../../utilities/typeGuardUtils";

import { ProcessMetadata } from "../workflows/data/processMetadata";

export interface WiedervorlageDocument extends Activity.Data.Document {
	root: Wiedervorlage;
}

export interface WiedervorlageProcessDocument extends Activity.Data.Document {
	root: Wiedervorlage;
	Process?: { processMetadata: ProcessMetadata };
}

export type Wiedervorlage = Partial<{
	Anlagedatum: Date;
	Erledigt: boolean;
	Faelligkeitsdatum: Date;
	ProcessId: string;
	Beschreibung: string;
	assignee: { id: string; firstName?: string | null; lastName?: string | null; fullName?: string | null } | null;
	[key: string]: number | boolean | Date | string | object | null;
}>;

export const isWiedervorlage = isObjectOf<Wiedervorlage>({
	ProcessId: isString
});

export const isWiedervorlageDocument = isObjectOf<WiedervorlageDocument>({
	root: isWiedervorlage
});

export const isWiedervorlageProcessDocument = isObjectOf<WiedervorlageProcessDocument>({
	root: isWiedervorlage
});

export interface WiedervorlageProcessOverviewData extends OverviewActivity.Data.DocumentListData {
	readonly documents: WiedervorlageProcessDocument[];
	readonly totalDocumentsCount: number;
}

export function isWiedervorlageProcessOverviewData(obj: object): obj is WiedervorlageProcessOverviewData {
	return (
		isRecord(obj) &&
		typeof obj.totalDocumentsCount === "number" &&
		isArrayOf(isWiedervorlageProcessDocument)(obj.documents)
	);
}
